export default __webpack_public_path__ + "static/media/Animals-17.13f7de22.png";